import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, LayoutGrid, UserCog } from "lucide-react";
import Logo from "@/components/brand/Logo";
import { useAuth } from "@/context/AuthContext";

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const item = ({ isActive }) => `inline-flex items-center gap-2 rounded-full px-4 h-10 text-sm font-semibold transition-colors ${isActive ? "bg-ds-creamalt text-ds-plum" : "text-ds-ink hover:bg-ds-creamalt/70"}`;

  return (
    <div className="min-h-screen bg-ds-cream">
      <header className="sticky top-0 z-40 border-b bg-ds-cream border-ds-plum/10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <Logo to="/dashboard" />
          <nav className="flex items-center gap-1">
            <NavLink to="/dashboard" end className={item} data-testid="portal-nav-dashboard"><LayoutGrid className="h-4 w-4" /><span className="hidden sm:inline">Dashboard</span></NavLink>
            <NavLink to="/account" className={item} data-testid="portal-nav-account"><UserCog className="h-4 w-4" /><span className="hidden sm:inline">Account</span></NavLink>
            <button
              onClick={async () => { await logout(); navigate("/login"); }}
              className="inline-flex items-center gap-2 rounded-full px-3 h-10 text-sm font-semibold text-ds-inksoft hover:bg-rose-50 hover:text-rose-700"
              data-testid="portal-logout-button"
              title={`Signed in as ${user?.email}`}
            >
              <LogOut className="h-4 w-4" /><span className="hidden sm:inline">Sign out</span>
            </button>
          </nav>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12"><Outlet /></main>
    </div>
  );
}
